import Button from "../Button";
import Chevron from "@/assets/icons/chevron.svg?react";
import ClockIcon from "@/assets/icons/clock.svg?react";
import AppHandIcon from "@/assets/icons/app-hand.svg?react";
import BPMonitorIcon from "@/assets/icons/bp-monitor.svg?react";
import { StepProps } from "@/data/onboarding/types";
import styles from "./Step.module.scss";

export default function MotivationStepNewPatient({ onAnswer }: StepProps) {
  return (
    <div>
      <p className="text-center">
        Vi hjälper över 22 000 patienter att hålla koll på sitt blodtryck
      </p>

      <div className="fw-500 font-17">
        <div className="flex gap-10 align-center">
          <ClockIcon />
          <span>Snabb och enkel utredning</span>
        </div>
        <div className="flex gap-10 align-center">
          <AppHandIcon />
          <span>Allt sker digitalt - du mäter hemma i lugn och ro</span>
        </div>
        <div className="flex gap-10 align-center">
          <BPMonitorIcon />
          <span>
            Du lånar blodtrycksmätare av oss och vi står för fraktkostnaden
          </span>
        </div>
      </div>

      <p>
        En utredning består oftast av en läkarkontroll men ibland behövs två för
        att utesluta sekundär hypertoni.
      </p>

      <div className={styles.formAction}>
        <Button onClick={() => onAnswer()} iconRight={<Chevron />}>
          Fortsätt
        </Button>
      </div>
    </div>
  );
}
